import type { SingleValueProps } from 'react-select';
import { components } from 'react-select';

import { SelectTeamOrMemberOption } from '#components/SelectTeamOrMember/SelectTeamOrMemberOption';
import type { TeamOrMemberOptionType } from '#components/SelectTeamOrMember/SelectTeamOrMemberUtils';

// This is what renders in the React Select input field for the selected option
export const SelectTeamOrMemberSingleValue = (singleValueProps: SingleValueProps<TeamOrMemberOptionType>) => {
  const option = singleValueProps.data;
  return (
    <components.SingleValue {...singleValueProps}>
      <SelectTeamOrMemberOption avatarSize="small" option={option} showEmail={false} />
    </components.SingleValue>
  );
};
